function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { sdkLogger } from '../logger';
/**
 * Helper class for managing DRM certificates
 */ export var DrmCertificateManager = /*#__PURE__*/ function() {
    "use strict";
    function DrmCertificateManager() {
        _class_call_check(this, DrmCertificateManager);
    }
    _create_class(DrmCertificateManager, null, [
        {
            key: "preload",
            value: /**
     *
     * @param drmConfig Configuration for DRM including a Widevine or Fairplay Certificate URL
     */ function preload(drmConfig) {
                var _drmConfig_widevine, _drmConfig_fairplay, _drmConfig_fairplay1;
                if (drmConfig === null || drmConfig === void 0 ? void 0 : (_drmConfig_widevine = drmConfig.widevine) === null || _drmConfig_widevine === void 0 ? void 0 : _drmConfig_widevine.certificateUrl) {
                    return DrmCertificateManager.preloadCert('widevine', drmConfig);
                }
                if ((drmConfig === null || drmConfig === void 0 ? void 0 : (_drmConfig_fairplay = drmConfig.fairplay) === null || _drmConfig_fairplay === void 0 ? void 0 : _drmConfig_fairplay.certificateUrl) && !(drmConfig === null || drmConfig === void 0 ? void 0 : (_drmConfig_fairplay1 = drmConfig.fairplay) === null || _drmConfig_fairplay1 === void 0 ? void 0 : _drmConfig_fairplay1.disablePrefetch)) {
                    return DrmCertificateManager.preloadCert('fairplay', drmConfig);
                }
            }
        },
        {
            key: "preloadCert",
            value: function preloadCert(drmType, drmConfig) {
                var _drmConfig_drmType;
                /**
         * This is an optional non-blocking optimisation.
         * If this loads in time before playout,
         * we'll use this certificate to prevent an extra acquire licence http request.
         */ var certificateUrl = drmConfig === null || drmConfig === void 0 ? void 0 : (_drmConfig_drmType = drmConfig[drmType]) === null || _drmConfig_drmType === void 0 ? void 0 : _drmConfig_drmType.certificateUrl;
                if (!certificateUrl) return;
                var controller = new AbortController();
                var timer = setTimeout(function() {
                    controller.abort();
                    onrejected("request failed to respond within ".concat(DrmCertificateManager.certUrlTimeout, " ms"));
                }, DrmCertificateManager.certUrlTimeout);
                var onResponse = function(response) {
                    clearTimeout(timer);
                    if (!response.ok) {
                        return Promise.reject(new Error("status: ".concat(response.status, ", statusText: ").concat(response.statusText)));
                    }
                    return response.arrayBuffer();
                };
                var onrejected = function(error) {
                    sdkLogger.error("Failed to preload ".concat(drmType, " certificate: ").concat(error));
                };
                var options = {
                    signal: controller.signal,
                    headers: {
                        'Content-Type': 'text/plain'
                    }
                };
                return fetch(certificateUrl, options).then(onResponse).then(function(certificate) {
                    drmConfig[drmType].certificate = certificate;
                }).catch(onrejected);
            }
        }
    ]);
    return DrmCertificateManager;
}();
_define_property(DrmCertificateManager, "certUrlTimeout", 4000);

//# sourceMappingURL=drm-certificate-manager.js.map